import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import googleDrive from "../../../../assets/Images/googleDrive.png";
import dropBox from "../../../../assets/Images/dropBox.png";
import env from "../../../../config/env";
import axios from "axios";
import DropboxChooser from "../../../../components/ThirdPartyServices/DropboxChooser";
import GoogleDrivePickers from "../../../../components/ThirdPartyServices/GoogleDrivePickers";
import { useUsersContext } from "../../../../context/usersContext";
import Icon from "../../../YourAIAgents/components/components/icon";
import { useUserInfo } from "../../../../context/user";
import MyDropzone from "../../../../components/addwebsites/MyDropzone";
import { AttachIcon } from "../WelcomeSections/InputIcons";

function Index({
  classname,
  chatId,
  onFileSelect,
}) {
  const BASE_URL = env.API_URL + "/v1";
  const {
    agencyInfo,
    contextuploadFilefrominput,
    SSO,
    enableChat,
    setUserAsUnread,
    refresh,
    justToSaveMsg,
    showToast,
    ChatSubmit,
  } = useUsersContext();
  const history = useNavigate();
  const [alertModel, setAlertModel] = useState(false);
  const [successModel, setSuccessModel] = useState(false);
  const [modelContent, setModelContent] = useState("");
  const [loader, setLoader] = useState(false);
  const [toggleOption, setToggleOption] = useState(false);
  const [selectFileModel, setSelectFileModel] = useState(false);
  const [mediaLibraryModel, setMediaLibraryModel] = useState(false);
  const [tempSelectedFiles, setTempSelectedFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [convertedFiles, setConvertedFiles] = useState([]);
  const [mediaLibraryData, setMediaLibraryData] = useState([]);
  const [tempSelectedFilesMedia, setTempSelectedFilesMedia] = useState([]);
  const [searchMediaTerm, setSearchMediaTerm] = useState("");
  const [userInfo, , , , userActiveLocation] = useUserInfo();

  const filteredMediaLibraryData = mediaLibraryData?.filter((item) =>
    item.name.toLowerCase().includes(searchMediaTerm.toLowerCase()),
  );

  const handleCloseModal = () => {
    setMediaLibraryModel(false); // Close the modal
    setSearchMediaTerm(""); // Clear the search term
  };

  const getMediaFiles = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/assistant/files/media-library?altId=${userActiveLocation?.id}&altType=location&objectId=${userActiveLocation?.id}&whichObject=account`,
      );
      if (response) {
        const files = response.data.data.files;

        // Set the media library data
        setMediaLibraryData(files);

        // Process and convert files
        const downloadedFiles = await downloadFiles(
          files?.map((file) => ({
            url: file.url,
            name: file.name,
            mimeType: file.contentType, // Assuming contentType corresponds to mimeType
          })),
        );

        // Store converted files in state
        setConvertedFiles(downloadedFiles);
      }
    } catch (error) {
      console.error("Error fetching media files:", error);
    }
  };

  // Helper function to download and convert files
  const downloadFiles = async (files) => {
    return Promise?.all(
      files?.map(async (file) => {
        try {
          const response = await fetch(file.url);
          const blob = await response.blob();
          return new File([blob], file.name, { type: file.mimeType });
        } catch (error) {
          console.error("Error downloading file:", error);
          return null;
        }
      }),
    ).then((results) => results.filter(Boolean));
  };

  useEffect(() => {
    getMediaFiles();
  }, []);

  const handleFileSelectMedia = (file) => {
    setTempSelectedFilesMedia((prev) => {
      const isAlreadySelected = prev.some(
        (selectedFile) => selectedFile.id === file.id,
      );
      if (isAlreadySelected) {
        // Remove the file if already selected
        return prev.filter((selectedFile) => selectedFile.id !== file.id);
      }
      // Add the file if not selected
      return [...prev, file];
    });
  };

  const handleDoneClickMedia = async () => {
    const assistant = [{ value: "asst_Cwkwlf4oUGjIWmuOrUiBqgx9" }];

    onFileSelect(convertedFiles);
    setMediaLibraryModel(false);
    setTempSelectedFilesMedia([]);
  };

  const handleAction = () => {
    setDisabled(true);
    setTimeout(() => setDisabled(false), 3000); // Disable for 3 seconds
  };

  const filteredData = Array.isArray(files)
    ? files.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    : [];

  const filteredFiles = filteredData.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleFileSelect = (file) => {
    setTempSelectedFiles((prevSelectedFiles) => {
      const isAlreadySelected = prevSelectedFiles.some(
        (selectedFile) => selectedFile.id === file.id,
      );
      if (isAlreadySelected) {
        return prevSelectedFiles.filter(
          (selectedFile) => selectedFile.id !== file.id,
        );
      } else {
        return [...prevSelectedFiles, file];
      }
    });
  };

  const handleDoneClick = () => {
    onFileSelect(tempSelectedFiles);
    setSelectFileModel(false);
    setToggleOption(false);
    setTempSelectedFiles([]);
  };

  const gettingfilefromdropzone = async (files) => {
    setLoader(true);
    const response = await contextuploadFilefrominput(
      files,
      chatId,
      setSpinnerLoading,
    );
    if (response?.data?.success === true) {
      // Case 1: `response.data.data` is available
      if (response?.data?.data) {
        onFileSelect(response.data.data);

        if (
          response?.data?.filetype === "audiofile" &&
          (!chatId || chatId === undefined)
        ) {
          const payload = {
            locationId: SSO?.id,
            username: SSO?.chat_username,
          };

          enableChat();

          const temp = await ChatSubmit(payload, true);

          if (!temp?.response) {
            refresh(temp);

            const chatUrl = `/chat/${temp.id}`;
            setUserAsUnread(temp.id);
            justToSaveMsg(response?.data?.data?.data, temp.id);
            history(chatUrl);
          }
          justToSaveMsg(response?.transcript, chatId);
        }

        // Show success modal for file upload
        setModelContent("File uploaded successfully!");
        setAlertModel(false);
        setSuccessModel(true);
        setSelectFileModel(false);
        setToggleOption(false);

        // If crash files also exist, show a toast for those
        if (
          response?.data?.crashfiles &&
          response?.data?.crashfiles.length > 0
        ) {
          showToast(
            `These files could not be uploaded due to a token expiration error: ${response.data.crashfiles.join(", ")}`,
          );
        }
      }
      // Case 2: No `response.data.data`, only `response.data.crashfiles`
      else if (
        response?.data?.crashfiles &&
        response?.data?.crashfiles.length > 0
      ) {
        showToast(
          `These files could not be uploaded due to a token expiration error: ${response.data.crashfiles.join(", ")}`,
        );
        setAlertModel(false);
        setLoader(false);
      }
    }
    // Case 3: No `data.data` and no `crashfiles`
    else {
      showToast(
        response?.message ? response?.message : `Something went wrong`,
        "err",
      );
      setLoader(false);
    }
  };

  const getUploadFiles = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/chat/assistants/files?profile_id=${userActiveLocation?.id}&user_id=${userInfo?._id}`,
      );
      if (response) {
        setFiles(response?.data?.data?.data);
        setSpinnerLoading(false);
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    getUploadFiles();
  }, [selectFileModel === true]);

  const threeDotRef = useRef(null);
  const hiddenFileInputRef = useRef(null);

  const handleNativeFilePick = (e) => {
    const picked = Array.from(e.target.files || []);
    e.target.value = "";
    if (picked.length === 0) return;
    onFileSelect(picked);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (threeDotRef.current && !threeDotRef.current.contains(event.target)) {
        setToggleOption(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [threeDotRef]);

  const filesFromThirdParty = async (files) => {
    var response = await contextuploadFilefrominput(
      files,
      chatId,
      setSpinnerLoading,
    );
    if (response?.data?.success === true) {
      onFileSelect(response?.data?.data);
    }
  };

  return (
    <div ref={threeDotRef}>
      <input
        ref={hiddenFileInputRef}
        type="file"
        multiple
        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp,text/plain,text/markdown,text/csv,.txt,.md,.csv,application/pdf,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.doc,.docx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xls,.xlsx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,.ppt,.pptx,audio/mpeg,audio/wav,audio/mp4,audio/x-m4a,audio/flac,.mp3,.wav,.m4a,.flac,video/mp4,video/mpeg,video/webm,.mp4,.mpeg,.webm,application/json,.json"
        style={{ display: "none" }}
        onChange={handleNativeFilePick}
      />
      {/* alerts */}
      {alertModel && (
        <>
          <div
            className="flex items-center justify-center fixed z-[99999] left-0 top-0 w-full h-full bg-[rgba(0,0,0,0.4)] overflow-auto"
            onClick={() => setAlertModel(false)}
          >
            <div
              className="bg-[#fefefe] m-auto py-8 px-1.5 border !border-[#888] w-[38%] rounded-[10px] relative h-[330px] overflow-auto rounded-[19px]"
              onClick={(e) => e.stopPropagation()}
            >
              <p
                className="absolute right-1 w-[12px] top-[10px] h-[12px] cursor-pointer"
                onClick={() => setAlertModel(false)}
              >
                X
              </p>

              <MyDropzone
                gettingfilefromdropzone={gettingfilefromdropzone}
                setLoader={setLoader}
                loader={loader}
              />
            </div>
          </div>
        </>
      )}

      {selectFileModel && (
        <div
          className="flex items-center justify-center fixed z-[9999] left-0 top-0 w-full h-full overflow-auto bg-[rgba(0,0,0,0.4)]"
          onClick={() => setSelectFileModel(false)}
        >
          <div
            className="bg-[#fefefe] m-auto py-8 px-9 border !border-[#888] w-[600px] rounded-[10px] relative max-h-[534px] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <p
              className="absolute right-1 w-[12px] top-[10px] h-[12px] cursor-pointer"
              onClick={() => setSelectFileModel(false)}
            >
              X
            </p>

            <div className="mb-8 flex justify-between items-center">
              <b className="text-black">Select a file</b>

              <input
                type="search"
                placeholder="Search"
                className="outline-none px-2 py-1.5 border !border-black rounded-[5px] w-1/2"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="max-h-[350px] overflow-auto">
              <div className="flex pl-7 pr-6">
                <p className="w-[33.33%] text-[14px] font-[500] mb-4">
                  File Name
                </p>
                <p className="text-center w-[33.33%] text-[14px] mb-4 font-[500]">
                  Date created
                </p>
                <p className="w-[33.33%] text-[14px] font-[500] mb-4"></p>
              </div>

              <div>
                {filteredFiles.length > 0 ? (
                  filteredFiles.map((item, index) => (
                    <div
                      className="flex rounded-[5px] border !border-[#e5e5e5] pl-7 pr-6 items-center mb-3"
                      key={index}
                    >
                      <p className="w-[33.33%] text-[12px] font-[400] m-0 px-0 py-5">
                        {item.name.length > 15
                          ? item.name.slice(0, 15) + "..."
                          : item.name}
                      </p>
                      <p className="w-[33.33%] text-[12px] font-[400] m-0 px-0 py-5 text-center">
                        {new Date(item.created_at).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </p>
                      <div className="w-[33.33%] items-start flex justify-end ">
                        <input
                          type="checkbox"
                          className="w-5 h-5 ml-auto bg-white text-black cursor-pointer"
                          onChange={() => handleFileSelect(item)}
                          checked={tempSelectedFiles.some(
                            (selectedFile) => selectedFile.id === item.id,
                          )}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="flex items-center mb-4">No files found</p>
                )}
              </div>
            </div>

            <button
              className="bg-black text-white rounded-[5px] font-[500] text-[14px] leading-[16.94px] text-center w-full p-[12px]"
              onClick={handleDoneClick}
            >
              Done
            </button>
          </div>
        </div>
      )}

      {mediaLibraryModel && (
        <div
          className="flex items-center justify-center fixed z-[99999] left-0 top-0 w-full h-full bg-black overflow-auto"
          onClick={handleCloseModal}
        >
          <div
            className="bg-[#fefefe] m-auto py-8 px-1.5 border !border-[#888] w-[600px] rounded-[10px] relative max-h-[534px] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <p
              className="absolute right-1 w-[12px] top-[10px] h-[12px] cursor-pointer"
              onClick={handleCloseModal}
            >
              X
            </p>

            <div className="mb-8 flex justify-between items-center">
              <b className="text-black">Select a file</b>

              <input
                type="search"
                placeholder="Search"
                className="outline-none px-2 py-1.5 border !border-black rounded-[5px] w-1/2"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="max-h-[350px] overflow-auto">
              <div className="flex pl-7 pr-6">
                <p className="w-[33.33%] text-[14px] font-[500] mb-4">
                  File Name
                </p>
                <p className="text-center w-[33.33%] text-[14px] mb-4 font-[500]">
                  Date created
                </p>
                <p className="w-[33.33%] text-[14px] font-[500] mb-4"></p>
              </div>

              <div>
                {filteredMediaLibraryData?.length > 0 ? (
                  filteredMediaLibraryData?.map((item, index) => (
                    <div
                      className="flex rounded-[5px] border !border-[#e5e5e5] pl-7 pr-6 items-center mb-3"
                      key={index}
                    >
                      <p className="w-[33.33%] text-[12px] font-[400] m-0 px-0 py-5">
                        {item.name.length > 15
                          ? item.name.slice(0, 15) + "..."
                          : item.name}
                      </p>
                      <p className="w-[33.33%] text-[12px] font-[400] m-0 px-0 py-5 text-center">
                        {new Date(item.created_at).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </p>
                      <div className="w-[33.33%] items-start flex justify-end ">
                        <input
                          type="checkbox"
                          className="w-5 h-5 ml-auto bg-white text-black cursor-pointer"
                          onChange={() => handleFileSelect(item)}
                          checked={tempSelectedFiles.some(
                            (selectedFile) => selectedFile.id === item.id,
                          )}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="flex items-center mb-4">No files found</p>
                )}
              </div>
            </div>

            <button
              className="bg-black text-white rounded-[5px] font-[500] text-[14px] leading-[16.94px] text-center w-full p-[12px]"
              onClick={handleDoneClick}
            >
              Done
            </button>
          </div>
        </div>
      )}

      <button aria-label="Send message" className={classname}>
        <div className="relative">
          <div
            className="outline-none  w-9 h-9 rounded-[5px]"
            onClick={() => {
              setToggleOption(!toggleOption);
              handleAction();
            }}
          >
            {spinnerLoading ? (
              <div className="mt-1 w-4 h-4 border-2 !border-[rbga(255,255,255,0.3)] !border-t-black rounded-[50%] animate-spin duration-[0.6s] linear"></div>
            ) : (
              <span
                className={`inline-flex items-center justify-center w-full h-full ${toggleOption ? "text-black" : "text-[#6b7280]"} hover:text-black`}
              >
                <AttachIcon size={18} />
              </span>
            )}
          </div>

          {toggleOption && (
            <div className="absolute bottom-7 left-2 w-[230px] bg-white rounded-[5px]">
              <div className="border !border-[#e5e5e5] !border-b-0 px-4 py-3 rounded-t-[5px]">
                <span className="flex items-center justify-start mb-4">
                  <img src={googleDrive} alt="googleDrive" className="mr-1.5" />
                  <GoogleDrivePickers
                    disabled={disabled}
                    files_send_to_parent={filesFromThirdParty}
                    setSpinnerLoading={setSpinnerLoading}
                  />
                </span>

                <span className="flex items-center justify-start">
                  <img src={dropBox} alt="googleDrive" className="mr-1.5" />
                  <DropboxChooser
                    disabled={disabled}
                    files_send_to_parent={filesFromThirdParty}
                    setSpinnerLoading={setSpinnerLoading}
                  />
                </span>
              </div>

              {/* <span>
                <img src={oneDrive} alt='googleDrive' style={{ marginRight: "7px" }} />
                <OneDrivePicker files_send_to_parent={filesFromThirdParty}  />
              </span> */}

              <div
                onClick={() => {
                  setToggleOption(false);
                  hiddenFileInputRef.current?.click();
                }}
                className="flex items-center justify-start border !border-[#e5e5e5] py-3 px-4 cursor-pointer"
              >
                <div className="pr-[7px]">
                  <Icon id="upload" />
                </div>
                <span className="text-[14px]">Upload From Computer</span>
              </div>

              <div
                className="flex items-center justify-start border !border-[#e5e5e5] !border-t-0 px-4 py-3 rounded-b-[5px]"
                onClick={() => {
                  setSelectFileModel(!selectFileModel);
                  setToggleOption(false);
                }}
              >
                <div className="pr-[7px] text-left">
                  <Icon id="selectFile" />
                </div>
                <span>Select a File</span>
              </div>
            </div>
          )}
        </div>
      </button>
    </div>
  );
}

export default Index;
